import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";

export default function AdminLayout({ children }) {
  return (
    <div className="flex min-h-screen bg-gray-900 text-white">
      <AdminSidebar />

      <div className="flex-1 flex flex-col">
        <AdminHeader />
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
